<template>
  <div id="contenedor-nueva-observacion">
    <v-form
      v-model="formularioValido"
      ref="registraNuevoAuditoriaInformeObservacion">
      <v-card>
        <v-card-title>
          Nueva Observación
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12">
              <SelectAuditoriaContratos
              :multiSelect="false"
              v-on:input="inputContrato"
              cols="12">
              </SelectAuditoriaContratos>
            </v-col>
            <!--
             <v-col cols="12" md="12">
             <CustomSelect
              v-model="observacion.idContrato"
              label="Cotrato"
              :items="getAuditoriaContratos"
              item-text="contrato"
              item-value="id">
            </CustomSelect>
            </v-col>
            -->
            <v-col cols="12" md="6">
              <TextField
                v-model="observacion.numero"
                label="Número"
                :rules="[mixReglas.requerido]">
              </TextField>
            </v-col>
            <v-col cols="12" md="6">
              <Select
                v-model="observacion.estatus"
                :items="getEstatusObservacion"
                label="Estatus"
                :rules="[mixReglas.requerido]">
              </Select>
            </v-col>
            <v-col cols="12" md="12">
              <TextArea
                v-model="observacion.descripcion"
                label="Descripción/Observación"
                rows="3"
                :rules="[mixReglas.requerido]">
              </TextArea>
            </v-col>
            <v-col cols="12" md="12">
              <TextArea
                v-model="observacion.medidaSolventacion"
                label="Medida de solventación"
                rows="3">
              </TextArea>
            </v-col>
            <v-col
              cols="12" md="6">
              <TextField
                v-model.number="observacion.montoOriginal"
                label="Monto original observado"
                es-dinero
                prefix="$">
              </TextField>
            </v-col>
            <v-col
              cols="12" md="6">
              <TextField
                v-model.number="observacion.montoPendiente"
                label="Monto por solventar"
                es-dinero
                prefix="$">
              </TextField>
            </v-col>
            <v-col cols="12" md="12">
              <TextArea
                v-model="observacion.comentarios"
                label="Comentarios"
                rows="3">
              </TextArea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
            </custom-button>
          <custom-button
            @click="guardar"
            tipo="formAceptar"
            label="Guardar"
            :disabled="!formularioValido || enviandoFormulario "
            :loading="enviandoFormulario"
            >
            </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import TextField from '@/components/inputs/sinColumnas/TextField.vue';
import TextArea from '@/components/inputs/sinColumnas/TextArea.vue';
import Select from '@/components/inputs/sinColumnas/Select.vue';
import CustomButton from '@/components/buttons/Button.vue';
// import CustomSelect from '@/components/inputs/Select.vue';
import SelectAuditoriaContratos from '@/components/administracion/auditorias/observaciones/AuditoriasContratosPicker.vue';
import mixObservaciones from './mixObservaciones';

const OBSERVACION_ESTATUS = [
  'Pendiente',
  'Por Responder',
  'Respuesta Enviada Parcial',
  'Respuesta Enviada Completa',
  'Solventada',
];

export default {
  name: 'RegistrarNuevaObservacion',
  mixins: [mixObservaciones],
  props: {
    informe: {
      type: Object,
      required: true,
    },
  },
  components: {
    TextField,
    TextArea,
    Select,
    SelectAuditoriaContratos,
    CustomButton,
    // CustomSelect,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      observacion: {
        idAuditoriaInforme: this.informe.id,
        idContrato: null,
        numero: '',
        descripcion: '',
        medidaSolventacion: null,
        montoOriginal: 0,
        montoPendiente: 0,
        estatus: 'PENDIENTE',
        fechaEstatus: new Date(),
        comentarios: null,
      },
    };
  },
  methods: {
    async guardar() {
      await this.mixAgregarAuditoriaInformeObservacion();
    },
    limpiarFormularioObservacion() {
      this.$refs.registraNuevoAuditoriaInformeObservacion.reset();
      this.observacion.estatus = 'PENDIENTE';
    },
    cerrar() {
      this.limpiarFormularioObservacion();
      this.$emit('cerrar');
    },
    inputContrato(contratoSeleccionado) {
      this.observacion.idContrato = contratoSeleccionado.id;
    },
  },
  computed: {
    getEstatusObservacion() {
      return OBSERVACION_ESTATUS.map((estatus) => estatus.toUpperCase());
    },
    getAuditoriaContratos() {
      if (!this.auditoriasContratos) return [];
      return this.auditoriasContratos.map((c) => ({
        contrato: c.contrato.numero,
        id: c.contrato.id,
      }));
    },
  },
};
</script>

<style lang="scss">

</style>
